import { Component, OnInit, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FloatInputComponent } from '../../float-input/float-input.component';
import { FiltreService } from 'src/app/shared/filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-float-input-keypad',
  templateUrl: './float-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class FloatInputKeypadComponent extends FloatInputComponent implements OnInit {
  @Input()
  valeurParDefaut: string;
  @Input()
    classeSupplementaire: string = '';
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }
  /**
   * Lorsque le champ n’est plus sélectionné, on peut le remplir automatiquement si une valeur par défaut est saisie.
   */
  public onBlur(): void {
    if (this.valeurParDefaut && this.rootForm.get(this.label).value === '') {
      this.rootForm.get(this.label).setValue(this.valeurParDefaut);
    }
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }

}
